module.exports = __webpack_public_path__ + "static/media/logo.ce18fd69.svg";